import { type ApiClient } from "@anna-money/anna-web-lib/api";
import { type ScaSignupData } from "./scaSignupTypes";

export class ScaSignupClient {
  private readonly _apiClient: ApiClient;

  constructor(apiClient: ApiClient) {
    this._apiClient = apiClient;
  }

  async signup(data: ScaSignupData): Promise<void> {
    await this._apiClient.post("api/formations/sca-signup", data);
  }
}
